import { useEffect, useState } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { useAlert } from 'react-alert'

import { FactorsCustomModel } from '../../../../domain/models'
import {
  fetchModelFactors,
  resetFactors,
  saveFactorModel,
  updateFactorModel
} from '../../../../main/usecases'

import { formatDate, goToUrl } from '../../../utils'
import { useModalBox, useOnChangeDetect } from '../../../contexts'
import {
  Button,
  SubHeader,
  EditorCard,
  Loading,
  ServicesHeader
} from '../../../components'

import { IconSaveSvg, IconReturnSvg } from '../../../assets/icons/svgComponents'

import * as S from './styles'

const Factor = () => {
  const [factor, setFactor] = useState<FactorsCustomModel[]>([])
  const [factorText, setFactorText] = useState('')
  const [htmlList, setHtmlList] = useState<any>({})
  const alert = useAlert()
  const location: any = useLocation()
  const history = useHistory()
  const { modalBox, modalClose } = useModalBox()
  const { refresh, setRefresh } = useOnChangeDetect()

  const handleOpenResetModal = () => {
    modalBox(
      <div className="delete-modal">
        <p className="attention-label">
          ATENÇÃO: Todas as edições serão perdidas
        </p>
        <p>Deseja realmente resetar o fator?</p>
        <div>
          <Button
            hasredButton
            onClick={() =>
              handleResetFactor(
                location.state.cdTypeToService || null,
                location.state.cdFactor || null
              )
            }
          >
            Sim
          </Button>
          <Button hasSecodaryButton onClick={modalClose}>
            Não
          </Button>
        </div>
      </div>,
      'Resetar Fator',
      '32%'
    )
  }

  const handleResetFactor = async (
    cdTypeToService: number | null,
    cdFactor: number | null
  ) => {
    try {
      if (cdTypeToService && cdFactor) {
        const responseToReset = await resetFactors({
          cdTypeToService: cdTypeToService,
          cdFactor: cdFactor
        }).load()
        modalClose(true)
        alert.show('Fator resetado com sucesso', {
          type: 'success',
          timeout: 4000
        })
        setFactor(responseToReset)
        setRefresh((prev: any) => !prev)
      }
    } catch (error) {
      console.error(error)
      alert.show('Erro ao resetar um Fator', {
        type: 'error',
        timeout: 4000
      })
    }
  }

  useEffect(() => {
    if (factor) {
      const texts = factor?.map((item) => item?.texto)
      setHtmlList(texts)
    }
  }, [factor, refresh])

  useEffect(() => {
    ;(async () => {
      try {
        if (!location?.state) goToUrl(history, '/fatores')

        const data = await fetchModelFactors({
          cdFactor: location?.state?.cdFactor,
          cdTypeToService: location?.state?.cdTypeToService
        }).load()
        setFactor(data)
      } catch (error) {
        console.error(error)
      }
    })()
  }, [history, location?.state, location?.state?.cdTypeToService])

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    const body = factor?.map((item, index) => {
      return {
        ...(item?.modeloAdm === false && {
          cdFatorResultado: item?.cdFatorResultado
        }),
        classificacao: item.classificacao,
        texto: htmlList[index] || factorText
      }
    })

    try {
      if (factor && factor[0]?.modeloAdm) {
        const responseToPost = await saveFactorModel({
          cdFactor: location.state.cdFactor,
          cdTypeToService: location.state.cdTypeToService
        }).post(body)
        alert.show('Salvo com sucesso!', {
          type: 'success',
          timeout: 4000
        })
        setFactor(responseToPost)
        setRefresh((prev: any) => !prev)
      } else {
        const responseToPut = await updateFactorModel().update(body)
        alert.show('Atualizado com sucesso!', {
          type: 'success',
          timeout: 4000
        })
        setFactor(responseToPut)
        setRefresh((prev: any) => !prev)
      }
    } catch (error) {
      alert.show('Error ao salvar/atualizar', {
        type: 'error',
        timeout: 4000
      })
      console.error(error)
    }
  }

  if (!document) return <Loading />

  return (
    <S.Wrapper>
      <SubHeader page="Voltar" link={`/fatores`} />
      <S.CardContainer>
        <ServicesHeader
          onClick={onSubmit}
          hasReset
          onReset={handleOpenResetModal}
          title={
            `${location?.state?.factorTitle} | ${location?.state?.serviceTitle}` ||
            ''
          }
        />
        {factor.map((item, index) => (
          <EditorCard
            data={item && item?.texto}
            setData={setFactorText}
            title={item && `${item.classificacao} | ${item?.fator.fator}`}
            onChangeContentToEditor={(html) => {
              setFactorText((prev: any) => ({
                ...prev,
                [index]: html
              }))
              setHtmlList((prev: any) => ({
                ...prev,
                [index]: html
              }))
            }}
          />
        ))}
        {factor.length ? (
          <S.ButtonsContainer>
            <Button
              initialIcon={<IconSaveSvg />}
              className="button-save"
              onClick={onSubmit}
            >
              Salvar
            </Button>
            <Button
              initialIcon={<IconReturnSvg />}
              hasSecodaryButton
              className="button-return-to-list"
            >
              <Link to={`/fatores`}>Retornar à listagem</Link>
            </Button>

            {factor[0]?.dataUltimaModificacao && (
              <p>
                Data da última atualização:{' '}
                {formatDate(factor[0]?.dataUltimaModificacao)}
              </p>
            )}
          </S.ButtonsContainer>
        ) : (
          ''
        )}
      </S.CardContainer>
    </S.Wrapper>
  )
}
export default Factor
